<template>
  <div class="layout">
  <div class="center-container">
  <slot />
  </div>
  </div>
  </template>
  <script>
  export default {
   name: "LoggedLayout",
  };
  </script>
  <style lang="scss" scoped>
  @import "@/assets/styles/form.scss";
  @import "vue-multiselect/dist/vue-multiselect.min.css";
  
  .layout {
   display: flex;
   flex-direction: column;
   width: 100%;
   height: 100vh;
   overflow-y: auto;
  }
  .center-container {
   width: 100%;
   max-width: 1700px; 
   margin: 0 auto;
   padding: 0 20px;
  }
  /* We can keep other style overrides here as needed */
  </style>